<template>
  <div class="cx-branded-card-collection">
    <div v-for="(card, i) in managementCards" :key="i">
      <branded-card v-if="!card.isMarginCard && !card.isCustomCard" 
                    class="card-large"
                    :brand="brand"
                    :theme="theme"
                    :title="card.title"
                    :name="card.name">
        <management-card  :brand="brand"
                          :card="card" 
                          class="mgmt-card"
                          :clientInfo="clientInfo"
                          :thresholds="thresholds">
          <template v-slot:default="slotProps">
            <management-table v-if="card.quarterly && slotProps.year < 2025" 
                              :customData="card" 
                              :data="card.quarterly" 
                              mode="quarterly"
                              class="sml-table"
                              :name="card.name"
                              :thresholds="thresholds"
                              :year="slotProps.year" />
            <management-table v-if="card.monthly && slotProps.year < 2025" 
                              :customData="card" 
                              :data="card.monthly" 
                              mode="monthly" 
                              class="lg-table"
                              :name="card.name"
                              :thresholds="thresholds"
                              :year="slotProps.year" />
            <template v-if="card.LeadManagement2025 && slotProps.year >= 2025" v-for="(e, i) in getLeadManagement2025(card.LeadManagement2025, slotProps.year)">
              <div class="leadmanagement2025-wrapper">
                <span style="margin-left: 0.5rem;"><b>{{ $t('Webportal.CX.Quarter') }} {{ e.Quarter }}</b></span>
                <br>
                <span style="margin-left: 0.5rem;">{{ $t('Webportal.CX.LastUpdated') }} {{ toLocaleDate(e.LastUpdated) }}</span>
                <management-table v-bind:key="`${i}-leadmanagement2025`"
                                :customData="card.LeadManagement2025" 
                                :data="[e]" 
                                mode="LeadManagement2025" 
                                class="sml-table"
                                name="LeadManagement2025"
                                :thresholds="thresholds"
                                :year="slotProps.year" />
                <span style="margin-left: 0.5rem;">
                  <b>
                    {{ $t('Webportal.CX.TotalFulfillment') }}
                    <span :style="{ 'color': `${getFulfillmentStatusColor(e.OverallFulfillmentStatus)}` }">{{ e.OverallFulfillmentStatus }}</span>
                  </b>
                </span>
              </div>
            </template>
          </template>
        </management-card>
      </branded-card>
          
      <div v-if="card.isMarginCard && card.isMarginCardSplitted">
        <branded-card :brand="brand"
                      v-for="(kpiGroup, i) in marginKpiGroups" :key="i"
                      :theme="theme"
                      :title="card.verticalCards[i].title" 
        >
          <management-card  v-if="true"
                            :brand="brand"
                            :card="card.verticalCards[i]" 
                            class="mgmt-card"
                            :fixHeader="true"
                            :clientInfo="clientInfo"
                            :clientLocationId="clientLocationId"
                            :thresholds="thresholds">
            <template v-slot:default="slotProps">
              <margin-kpi-group :clientLocationId="clientLocationId"
                                :kpiGroup="kpiGroup" 
                                :brand="brand"
                                :fixHeader="true"
                                :openPopup="openKpiPopup" 
                                :colorRange="thresholds"
                                :isHealingDeactivated="false"
                                :year="slotProps.year"
                                :currentWave="currentWave" />
            </template>
          </management-card>
        </branded-card>
      </div>
    
      <div v-if="card.isCustomCard">
        <branded-card :brand="brand"
                      :theme="theme"
                      :title="card.verticalCards[0].title"
                      class="card-regular"
                      :name="card.verticalCards[0].name">
          <management-card  :brand="brand"
                            :card="card.verticalCards[0]" 
                            class="mgmt-card"
                            :clientInfo="clientInfo"
                            :thresholds="thresholds">
            <template v-slot:default="slotProps">
              <management-table v-if="card.verticalCards[0].quarterly" 
                                :customData="card.verticalCards[0]" 
                                :data="card.verticalCards[0].quarterly"
                                mode="quarterly"
                                class="sml-table"
                                :name="card.verticalCards[0].name"
                                :thresholds="thresholds"
                                :year="slotProps.year" />
            </template>
          </management-card>
        </branded-card>

        <branded-card v-if="card.verticalCards[1]"
                      :brand="brand"
                      :theme="theme"
                      :title="card.verticalCards[1].title" 
                      :selectionMode="card.verticalCards[1].selectionMode"
                      class="card-regular"
                      :name="card.verticalCards[1].name">
          <management-card  :card="card.verticalCards[1]"
                            :brand="brand"
                            class="mgmt-card"
                            :clientInfo="clientInfo"
                            :selectionMode="card.verticalCards[1].selectionMode"
                            :thresholds="thresholds">
            <template v-slot:default="slotProps">
              <template v-if="card.verticalCards[1].ContactQuota2025 && card.verticalCards[1].ContactQuota2025.quarterly && slotProps.year >= 2025">
                <span style="margin-left: 0.5rem;">{{ $t('Webportal.CX.LastUpdated') }} {{ getContactQuotaLAstUpdated(card.verticalCards[1].ContactQuota2025) }}</span>
                <management-table :customData="card.verticalCards[1].ContactQuota2025" 
                                  :data="card.verticalCards[1].ContactQuota2025.quarterly" 
                                  mode="quarterly"
                                  class="sml-table"
                                  :name="'ContactQuota2025'"
                                  :thresholds="thresholds"
                                  :selection="slotProps.selectedItem"
                                  :year="slotProps.year" />
              </template>
              <management-table v-else-if="card.verticalCards[1].quarterly" 
                                :customData="card.verticalCards[1]" 
                                :data="card.verticalCards[1].quarterly" 
                                mode="quarterly"
                                class="sml-table"
                                :name="card.verticalCards[1].name"
                                :thresholds="thresholds"
                                :selection="slotProps.selectedItem"
                                :year="slotProps.year" />

              <management-table v-else-if="card.verticalCards[1].monthly" 
                                :customData="card.verticalCards[1]" 
                                :data="card.verticalCards[1].monthly" 
                                mode="monthly"
                                :name="card.verticalCards[1].name"
                                :thresholds="thresholds"
                                :selection="slotProps.selectedItem"
                                :year="slotProps.year" />
            </template>
          </management-card>
        </branded-card>
      </div>
    </div>
    
    <MarginKpiPopup v-if="showKpiPopup"
                    :ColorRange="thresholds"
                    :ClientLocationId="clientLocationId"
                    :Kpi="selectedKpi"
                    :WaveName="selectedWave"
                    :Brand="brand"
                    @close="hideKpiPopup()" />
  </div>
</template>

<script>
import BrandedCard from '@/components/CX/DashboardCards/BrandedCard';
import DashboardService from "@/services/DashboardService-APP_TARGET";
import DateMixin from '@/mixins/DateMixin';
import EventBus from "@/services/EventBus";
import ManagementCard from '@/components/CX/DashboardCards/ManagementCard';
import ManagementTable from '@/components/CX/DashboardCards/ManagementTable';
import MarginKpiGroup from '@/components/CX/MarginKpiGroup.vue';
import MarginKpiMixin from '@/mixins/MarginKpiMixin';
import MarginKpiPopup from "@/components/CX/MarginKpiPopup.vue";
import MarginKpiStatusIndicator from '@/components/CX/MarginKpiStatusIndicator.vue';
import { i18n } from "@/i18n";

export default {
  mixins: [ DateMixin, MarginKpiMixin ],

  components: {
    BrandedCard,
    ManagementCard,
    ManagementTable,
    MarginKpiPopup, 
    MarginKpiGroup, 
    MarginKpiStatusIndicator
  },

  props: {
    brand:                        { type: String,  default: 'Jaguar' },
    clientInfo:                   { type: Object,  default: undefined },
    clientLocationId:             { type: Number, required: true },
    marginKpiGroups:              { type: Array,  required: true },
    showLeadingMarginEvaluation:  { type: Boolean, default: true },
    thresholds:                   { type: Array,  required: true },
    theme:                        { type: String,  default: () => 'light' },
    title:                        { type: String,  default: '' }
  },

  data() {
    return {
      isLoading: true,
      managementCards: [],
      inControl: undefined,
      
      KpiIds: [],

      showKpiPopup: false,
      selectedKpi: null,
      selectedWave: null,
    };
  },

  mounted() {
    this.init();

    // Hmm kay, this is hacky ... but shows the correct values ...
    let self = this;
    setTimeout(function() { self.$forceUpdate() }, 1500);

    EventBus.$on("refresh-margin-card", this.loadMarginKpiData);
  },

  methods: {
    getContactQuotaLAstUpdated(data) {
      if(data.quarterly && data.quarterly.length) {
        let date;
        for (let index = 0; index < data.quarterly.length; index++) {
          const quarter = data.quarterly[index];
          if(index === 0) {
            date = new Date(quarter.LastUpdated);
          } else {
            let newDate = new Date(quarter.LastUpdated);
            if(newDate > date) date = newDate;
          }
        }
        if(!date) return null;
        return date.toLocaleDateString();
      } else {
        return null;
      }
    },
    toLocaleDate(dateString) {
      let d = new Date(dateString);
      return d.toLocaleDateString();
    },
    getFulfillmentStatusColor(text) {
      if(text.toLowerCase().trim().startsWith('nicht erfüllt')) return this.thresholds.find(s => s.Smiley == "frown-open")?.Color;
      else if(text.toLowerCase().trim().startsWith('erfüllt')) return this.thresholds.find(s => s.Smiley == "grin")?.Color;
      else return ""
    },
    getFulfilledCount(e) {
      let countFulfilled = ((e.E1FulfilledLeads ? e.E1FulfilledLeads : 0) + (e.E2FulfilledLeads ? e.E2FulfilledLeads : 0) + (e.E3FulfilledLeads ? e.E3FulfilledLeads : 0));
      return countFulfilled;
    },
    getUnfulfilledCount(e) {
      let countFulfilled = ((e.E1FulfilledLeads ? e.E1FulfilledLeads : 0) + (e.E2FulfilledLeads ? e.E2FulfilledLeads : 0) + (e.E3FulfilledLeads ? e.E3FulfilledLeads : 0));
      let countTotal = ((e.E1TotalLeads ? e.E1TotalLeads : 0) + (e.E2TotalLeads ? e.E2TotalLeads : 0) + (e.E3TotalLeads ? e.E3TotalLeads : 0));
      return (countTotal - countFulfilled);
    },
    getLeadManagement2025(leadManagement2025, year) {
      if(!leadManagement2025.fulfillmentRate) return;
      return leadManagement2025.fulfillmentRate.filter(e => e.Year === year);
    },
    async init() {
      this.calculateCurrentWaveForHealing();
      await this.loadMarginKpiData();
      await this.loadInControlData();
      var marginManagementData = await this.loadMarginManagementData();

      this.managementCards = this.initData(marginManagementData);
      this.isLoading = false;
    },
    openKpiPopup(kpi, wave) {
      if(kpi.SurveyWave.find(x => x.Name == wave)) {
        if (this.selectedKpi == kpi && this.selectedWave == wave) {
          this.hideKpiPopup();
        } else {
          kpi.ShowPopup = true; 
          this.selectedKpi = kpi;
          this.selectedWave = wave;
          this.showKpiPopup = true; 
        } 
      } else {
        this.hideKpiPopup();
      }
    },

    hideKpiPopup() {
      this.selectedKpi = null;
      this.selectedWave = null;
      this.showKpiPopup = false;
    },

    showLeadingMargin() {
      let counts = this.marginKpiGroups.map(x => x.SurveyWave.length);
      let count = counts.reduce((pv, cv) => pv + cv, 0);
      if (count === 0)
        return false;
      return this.showLeadingMarginEvaluation;
    },

    async loadMarginManagementData() {
      return DashboardService.GetMarginManagementData(this.clientLocationId, this.brand)
        .then(res => {
          return res.data;
        })
        .catch(error => {
          console.error("LOAD lead management failed", error)
        })
    },

    async loadInControlData() {
      return DashboardService.GetInControlData(this.clientLocationId, this.brand)
        .then(res => {
          this.inControl = res.data.InControl[0];
        })
        .catch(error => {
          console.error("LOAD InControl failed", error)
        })
    },

    async loadMarginKpiData() {
      this.marginKpiGroups.forEach(kpiGroup => {
        kpiGroup.Items.forEach(kpi => {
          this.KpiIds.push(kpi.SurveyKpiIds)
        });
      });
      
      let self = this;
      return Promise.all([
        this.getKpisByYear(self.marginKpiGroups).catch(e => _), 
        this.getWaves(self.marginKpiGroups).catch(e => _)]
      )
      .then(() => {
        this.calculateWaveTotalResults(self.marginKpiGroups);
      })
    },

    getWaves(groups) {
      var promises = []
      groups.forEach(kpiGroup => {
        var waveIds = kpiGroup.SurveyWave.map(wave => wave.Id);
        if(waveIds.length > 0) {
          promises.push(DashboardService.GetSurveyWavesOfSameSurvey(waveIds.toString())
            .then((res) => {
            kpiGroup.Waves = res.data;
              kpiGroup.Items.forEach(kpi => {
                kpi.Waves = res.data;
              });
            })
            .catch((error) => {
              console.error(error);
            }))
        }
      })
      return Promise.all(promises)
    },
    
    getKpisByYear(groups) {
      const kpiids = this.KpiIds.filter(id => id != "");
      if(kpiids.length == 0 ) 
        return Promise.reject("kpis empty");
      //TODO: Exchange 2022 with the selected year
      return DashboardService.GetSurveyKpisByYear(this.KpiIds.toString(), i18n.locale, this.clientLocationId, 2022)
        .then(res => {
          return res.data == "" ? { data: [] } : res;
        })
        .then(res => {
          res.data.waveKpiResults.forEach(kpiResult => {
            groups.forEach(kpiGroup => {
              kpiGroup.availableYears = res.data.availableYears;
              kpiGroup.Items.forEach(kpi => {
                if( kpi.Code == kpiResult.KpiCode && kpi.GroupCode == kpiResult.KpiGroupCode) {
                  kpi.SurveyWave.push({
                    "CalculationMode": kpiResult.CalculationMode,
                    "SurveyWaveIds": kpiResult.SurveyWaveIds,
                    "Name": kpiResult.SurveyWaveName,
                    "PointsReached": kpiResult.PointsReached,
                    "PointsMax": kpiResult.PointsMax,
                    "Result": kpiResult.Result,
                    "Scenario": kpiResult.ScenarioName,
                    "KpiGroupName": kpiResult.KpiGroupName,
                    "Accomplished": kpiResult.Result == 1
                  })
                }
              })
            })
          })
        })
    },

    calculateWaveTotalResults(groups) {
      for(var groupIndex = 0; groupIndex < groups.length; groupIndex++) {
        for(var waveIndex = 0; waveIndex < groups[groupIndex].Waves.length; waveIndex ++) {
          let count = null;
          let correctKpiCounter = null;
          for (var itemIndex = 0; itemIndex < groups[groupIndex].Items.length; itemIndex++){
            if( groups[groupIndex].Items[itemIndex].Code === "Video Chat - Sophus3 2023 (monthly)") continue;
            var x = groups[groupIndex].Items[itemIndex].SurveyWave.find(y => y.Name == groups[groupIndex].Waves[waveIndex].NameShort);
            if(x) {
              count++;
              correctKpiCounter += x.Result == 1 ? 1 : 0;
            };
          };
          if(count != null) {
            groups[groupIndex].Waves[waveIndex].Result = (correctKpiCounter / count);
          } else {
            groups[groupIndex].Waves[waveIndex].Result = null
          }
        }
      }
    },

    initCategory(items, title, name, button, months, jagMargin, lrMargin) {
      if (!items)
        return;

      if (_.isEmpty(items.availableYears)) 
        items.availableYears = [];
      if (_.isEmpty(items.quarterly))
        items.quarterly = [];
      if (months && _.isEmpty(items.monthly))
        items.monthly = [];

      if (jagMargin && lrMargin) {
        let margin = this.$n(this.brand == 'Jaguar' ? jagMargin : lrMargin, { minimumFractionDigits: 1, maximumFractionDigits: 1});
        items.subtitle = `${margin}% Margin`;
      }

      items.button = button;
      items.title = title;
      items.name = name;
      items.brand = this.brand;
    },

    getQuarters(item) {
      // make sure no collection is undefined
      if (item.quarterly === undefined)
        item.quarterly = [];
      return item.quarterly;
    },

    calculateActualQuarter(data) {
      // letztes Quartal ermitteln
      let maxxes = [];
      maxxes.push(Math.max(...this.getQuarters(data.LeadManagement).map(x => x.Quarter)));
      maxxes.push(Math.max(...this.getQuarters(data.ClosedRedFlags).map(x => x.Quarter)));
      maxxes.push(Math.max(...this.getQuarters(data.ContactQuota).map(x => x.Quarter)));
      maxxes.push(Math.max(...this.getQuarters(data.NPS).map(x => x.Quarter)));
      return (maxxes.length < 1) ? undefined : Math.max(...maxxes);
    },
    
    setAllYears(data) {
      // TODO: RETAIL Marketing und Händler Performance ... evtl. auch noch dazu
      let uniqueYears = _.uniq([ 
        ...data.LeadManagement.availableYears,
        ...data.ClosedRedFlags.availableYears,
        ...data.ContactQuota.availableYears,
        ...data.NPS.availableYears ]);
      
      if (uniqueYears.length === 0) 
        uniqueYears.push(new Date().getFullYear()); 
      
      uniqueYears = _.sortedUniq(uniqueYears).reverse(); // [ 2023, 2022, 2021 ];

      data.LeadManagement.availableYears = uniqueYears;
      data.ClosedRedFlags.availableYears = uniqueYears;
      data.ContactQuota.availableYears = uniqueYears;
      data.NPS.availableYears = uniqueYears;

      return uniqueYears;
    },

    fillUpQuarterlyResults(quarterList, availYears, lastActiveQuarter, itemTemplate) {
      let actualYear = new Date().getFullYear();
      for (let j = 0; j < availYears.length; j++) {
        let maxQuarters = availYears[j] < actualYear ? 4 : lastActiveQuarter;
        for (let i = 1; i <= maxQuarters; i++) {
          const element = quarterList.find(x => x.Quarter === i && x.Year === availYears[j]);
          if (!element && availYears[j] <= actualYear) {
            let item = JSON.parse(JSON.stringify(itemTemplate));
            item.Year = availYears[j];
            item.Quarter = i;
            quarterList.push(item);
          }
        }
      }
    },

    initData(data) {
      if (!data)
        return [];

      let actualQuarter = this.calculateActualQuarter(data);
      let closedQuarter = this.getClosedQuarter();

      this.initCategory(data.LeadManagement, 'Webportal.CX.LeadManagement', 'LeadManagement', true, true, 1.5, 1.0);
      this.initCategory(data.ClosedRedFlags, 'Webportal.CX.CustomerFirstNpsRfc', 'ClosedRedFlags', false, true, 0.5, 0.3);
      this.initCategory(data.ContactQuota, 'Webportal.CX.CustomerFirstNpsContactQuota', 'ContactQuota', true, false, 0.8, 0.7);
      this.initCategory(data.NPS, 'Webportal.CX.CustomerFirstNpsNps', 'NPS', false, false, 0.5, 0.3);

      data.InControl = { 
        title: "InControl",
        height: '720px!important',
        subtitle: this.$t('Webportal.CX.EntryRequirement'),
        availableYears: this.inControl.availableYears,
        button: true,
        popupWidth: 800, 
        name: "InControl",
        brand: this.brand,
        details: this.inControl.details,
        quarterly: this.inControl.quarterly,
        monthly: this.inControl.monthly
      };
      this.initCategory(data.InControl, "Webportal.CX.InControl", "InControl", false, false, null, null);
      data.InControl.button = true;
      data.InControl.selectionMode = 'monthly';

      let availYears = this.setAllYears(data);

      // NPS auffüllen
      this.fillUpQuarterlyResults(data.NPS.quarterly, availYears, Math.min(actualQuarter, closedQuarter), 
        { FullfilledContactQuota: undefined, FullfilledNPS: undefined });
      // RF Schließung auffüllen
      this.fillUpQuarterlyResults(data.ClosedRedFlags.quarterly, availYears, Math.min(actualQuarter, closedQuarter), 
        { TotalRedFlags: 0, ClosedRedFlags: 0, CloseTime: 0 });

      let dh = { 
        title: this.$t('Webportal.CX.DigitalDealerPerformance'),
        height: '614px!important',
        subtitle: this.marginKpiGroups[0].KpiGroupNameLong,
        availableYears: this.marginKpiGroups[0].availableYears,
        button: true,
        popupWidth: 600,
        name: this.$t('Webportal.CX.DigitalDealerPerformance'),
        brand: this.brand
      };

      if(data.LeadManagement && data.LeadManagement2025) {
        data.LeadManagement.LeadManagement2025 = data.LeadManagement2025;
      }
      if(data.ContactQuota && data.ContactQuota2025) {
        data.ContactQuota.ContactQuota2025 = data.ContactQuota2025;
      }

      let results = [ data.LeadManagement ];
      // { isMarginCard: true }, // old Version
      if (dh.availableYears) {
        results.push({ verticalCards: [ dh ], isMarginCard: true, isMarginCardSplitted: true });
      }
      results.push({ verticalCards: [data.ClosedRedFlags, data.ContactQuota], isCustomCard: true });
      results.push({ verticalCards: [data.NPS, data.InControl], isCustomCard: true });
      return results.filter(item => item !== undefined);
    }
  }
};
</script>

<style scoped>
  .cx-branded-card-collection {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-gap: 1rem;
    width: calc(100% - 3rem);
    min-width: 1366px;
  }

  .lg-margincard {
    max-width: unset !important;
  }

  .card-regular {
    height: 30rem;
    margin-bottom: 1.5rem;
  }

  .card-large {
    /* height: 61.5rem; */
    min-height: 30rem;
  }

  .card-upper {
    margin-bottom: 1.5rem;
    height: 20.5rem;
  }

  .card-lower {
    height: 39.5rem;
  }

  .sml-table {
    /* height: 15rem; */
  }
  .lg-table {
    /* height: 29.5rem; */
  }
  .leadmanagement2025-wrapper {
    border-bottom: 1px solid var(--color-accent);
    padding-bottom: 1rem;
  }
</style>
